import { FC, ReactNode, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import cx from 'classnames';
import { useOnClickOutside } from '@/hooks';

import styles from './DropdownPanel.module.sass';

interface DropdownPanelProps {
  isActive?: boolean;
  className?: string;
  children: ReactNode;
  onClose: () => void;
}

const DropdownPanel: FC<DropdownPanelProps> = ({
  isActive,
  children,
  className,
  onClose,
}) => {
  const panelRef = useRef(null);

  useOnClickOutside([panelRef], onClose, undefined, []);

  const classes = cx(styles.panel, className);

  return (
    <CSSTransition
      nodeRef={panelRef}
      in={isActive}
      timeout={300}
      unmountOnExit
      appear
    >
      <div className={classes} ref={panelRef}>
        {children}
      </div>
    </CSSTransition>
  );
};

DropdownPanel.defaultProps = {
  isActive: false,
  className: '',
};

export default DropdownPanel;
